import { render } from "./EditPasskeyDialog.vue?vue&type=template&id=649a742e"
import script from "./EditPasskeyDialog.vue?vue&type=script&lang=js"
export * from "./EditPasskeyDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__